/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/mobilephone_medium'
export default icon
